module.exports = __webpack_public_path__ + "img/phone-white.b131dc6d.svg";